import { apiSlice } from "./apiSlice";
import {
  GET_SPONSORED_PRODUCTS,
  GET_TOP_SELLING_PRODUCTS,
  GET_PRODUCT_BY_ID_URL,
  GET_LATEST_PRODUCTS_URL,
  GET_REVIEWS_BY_PRODUCT_ID_URL,
  GET_ALL_PRODUCTS_URL,
  SEARCH_PRODUCTS_URL,
  SEARCH_PAGE_PRODUCTS_URL,
  GET_SHOP_PRODUCTS_URL,
} from "../constants";

export const productSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getSponsoredProducts: builder.query({
      query: () => ({
        url: GET_SPONSORED_PRODUCTS,
        method: "GET",
      }),
    }),
    getTopSellingProducts: builder.query({
      query: () => ({
        url: GET_TOP_SELLING_PRODUCTS,
        method: "GET",
      }),
    }),
    getProductById: builder.query({
      query: (id) => ({
        url: GET_PRODUCT_BY_ID_URL(id),
        method: "GET",
      }),
    }),
    getLatestProducts: builder.query({
      query: () => {
        const location = localStorage.getItem("location"); // Get location from localStorage
        return {
          url: GET_LATEST_PRODUCTS_URL(location),
          method: "GET",
        };
      },
    }),
    getProductReviews: builder.query({
      query: (productId) => ({
        url: GET_REVIEWS_BY_PRODUCT_ID_URL(productId),
        method: "GET",
      }),
    }),
    getAllProducts: builder.query({
      query: () => {
        const location = localStorage.getItem("location"); // Get location from localStorage
        return {
          url: GET_ALL_PRODUCTS_URL(location),
          method: "GET",
        };
      },
    }),
    searchProducts: builder.query({
      query: (query) => {
        const location = localStorage.getItem("location"); // Get location from localStorage
        return {
          url: SEARCH_PRODUCTS_URL(query, location),
          method: "GET",
        };
      },
    }),
    searchPageProducts: builder.query({
      query: ({ query, location, filters, page, limit, sort }) => ({
        url: SEARCH_PAGE_PRODUCTS_URL(query, location, filters),
        params: { page, limit, sort }, // Pagination and sorting
        method: "GET",
      }),
    }),

    // getShopProducts: builder.query({
    //   query: ({ page = 1, limit = 16, sort = "latest", filters }) => {
    //     const location = localStorage.getItem("location");
    //     return {
    //       url: GET_SHOP_PRODUCTS_URL,
    //       params: {
    //         page,
    //         limit,
    //         sort,
    //         location,
    //         filters: JSON.stringify(filters),
    //       },
    //       method: "GET",
    //     };
    //   },
    // }),
    getShopProducts: builder.query({
      query: ({ page = 1, limit = 16, sort = "latest", filters }) => {
        const location = localStorage.getItem("location"); // 🔥 PROBLEM: using localStorage immediately
        return {
          url: GET_SHOP_PRODUCTS_URL,
          params: {
            page,
            limit,
            sort,
            location,
            filters: JSON.stringify(filters),
          },
          method: "GET",
        };
      },
    }),
  }),
});

export const {
  useGetSponsoredProductsQuery,
  useGetTopSellingProductsQuery,
  useGetProductByIdQuery,
  useGetLatestProductsQuery,
  useGetProductReviewsQuery,
  useGetAllProductsQuery,
  useSearchProductsQuery,
  useSearchPageProductsQuery,
  useGetShopProductsQuery,
} = productSlice;
